var _path, _path2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgPosition = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66685 5.77694V5.11027C6.66685 3.63527 6.66685 2.4436 9.33351 2.4436H10.6668C13.3335 2.4436 13.3335 3.63527 13.3335 5.11027V5.77694M6.66685 19.1103H13.3335C16.6835 19.1103 17.2835 17.7686 17.4585 16.1353L18.0835 9.4686C18.3085 7.43527 17.7252 5.77694 14.1668 5.77694H5.83351C2.27518 5.77694 1.69185 7.43527 1.91685 9.4686L2.54185 16.1353C2.71685 17.7686 3.31685 19.1103 6.66685 19.1103Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0414 9.9436C16.1632 11.3077 13.9699 12.1735 11.6664 12.4603M2.18311 10.1686C4.05811 11.4519 6.17477 12.2269 8.3331 12.4686M11.6664 11.6103V12.4603C11.6664 13.3686 11.6581 14.1103 9.99977 14.1103C8.34977 14.1103 8.3331 13.3769 8.3331 12.4686V11.6103C8.3331 10.7769 8.3331 10.7769 9.16644 10.7769H10.8331C11.6664 10.7769 11.6664 10.7769 11.6664 11.6103Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPosition, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/position.695f62c0.svg";
export { ForwardRef as ReactComponent };